module.exports = __webpack_public_path__ + "static/media/color_logo_transparent.7a859aa2.png";